<template>
    <div class="switchButton">
        <el-switch v-model="value.val" @change="change"></el-switch>
    </div>
</template>
<script>
    export default {
        props:{
            value:{
                type: Object,
                default: {}
            }
        },
        data(){
            return{}
        },
        methods:{
            change(value){
                this.$emit("change")
            }
        }
    }
</script>
<style scoped lang="scss">
.switchButton{
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
}
</style>